module.exports = __webpack_public_path__ + "static/media/recent.7e70ad54.svg";